import { 
  ResizeHandle, 
} from '../components/SlideCanvas.types';
import { normalizeRotation } from './slideRotation';

export const RESIZE_HANDLE_VISUAL_RADIUS = 4;

/**
 * Angle thresholds (in degrees) for determining the appropriate resize cursor.
 * Each cursor covers a 45-degree sector centered around its primary axis.
 */
const CURSOR_ANGLE_NS_START = 22.5;
const CURSOR_ANGLE_NESW_START = 67.5;
const CURSOR_ANGLE_EW_START = 112.5;
const CURSOR_ANGLE_NWSE_START = 157.5;
const CURSOR_ANGLE_NS_OPPOSITE_START = 202.5;
const CURSOR_ANGLE_NESW_OPPOSITE_START = 247.5;
const CURSOR_ANGLE_EW_OPPOSITE_START = 292.5;
const CURSOR_ANGLE_NWSE_OPPOSITE_START = 337.5;

/**
 * Calculates the appropriate CSS cursor string (e.g., 'nwse-resize') for a
 * given resize handle, taking into account the current rotation of the box.
 * This ensures the cursor arrows visually align with the screen even if the box is rotated.
 * 
 * @param handle The resize handle the pointer is hovering over.
 * @param rotation The current rotation of the bounding box.
 * @returns The CSS cursor value.
 */
export function getHandleCursor(handle: ResizeHandle, rotation: number): string {
  if (!handle) return 'default';
  const angles: Record<string, number> = {
    NorthWest: 315,
    NorthEast: 45,
    SouthEast: 135,
    SouthWest: 225,
  };
  const rotatedAngle = normalizeRotation(angles[handle] + rotation);

  if (rotatedAngle >= CURSOR_ANGLE_NWSE_OPPOSITE_START || rotatedAngle < CURSOR_ANGLE_NS_START) return 'ns-resize';
  if (rotatedAngle >= CURSOR_ANGLE_NS_START && rotatedAngle < CURSOR_ANGLE_NESW_START) return 'nesw-resize';
  if (rotatedAngle >= CURSOR_ANGLE_NESW_START && rotatedAngle < CURSOR_ANGLE_EW_START) return 'ew-resize';
  if (rotatedAngle >= CURSOR_ANGLE_EW_START && rotatedAngle < CURSOR_ANGLE_NWSE_START) return 'nwse-resize';
  if (rotatedAngle >= CURSOR_ANGLE_NWSE_START && rotatedAngle < CURSOR_ANGLE_NS_OPPOSITE_START) return 'ns-resize';
  if (rotatedAngle >= CURSOR_ANGLE_NS_OPPOSITE_START && rotatedAngle < CURSOR_ANGLE_NESW_OPPOSITE_START) return 'nesw-resize';
  if (rotatedAngle >= CURSOR_ANGLE_NESW_OPPOSITE_START && rotatedAngle < CURSOR_ANGLE_EW_OPPOSITE_START) return 'ew-resize';
  if (rotatedAngle >= CURSOR_ANGLE_EW_OPPOSITE_START && rotatedAngle < CURSOR_ANGLE_NWSE_OPPOSITE_START) return 'nwse-resize';

  return 'default';
}
